// src/services/api/employeeCommission.js
import { apiClient } from './base';

// ─── Config API ──────────────────────────────────────────────────────────────

export const getEmployeeLevelConfigs = async (params = {}) => {
  const response = await apiClient.get('/employee-commission/configs/employees', { params });
  return response.data;
};

export const getProductLevelConfigs = async (params = {}) => {
  const response = await apiClient.get('/employee-commission/configs/products', { params });
  return response.data;
};

export const getEmployeeProductConfigs = async (userId, params = {}) => {
  const response = await apiClient.get(`/employee-commission/configs/employees/${userId}/products`, { params });
  return response.data;
};

export const getProductEmployeeConfigs = async (productId, params = {}) => {
  const response = await apiClient.get(`/employee-commission/configs/products/${productId}/employees`, { params });
  return response.data;
};

export const upsertCommissionConfig = async (data) => {
  const response = await apiClient.post('/employee-commission/configs', data);
  return response.data;
};

export const bulkUpsertCommissionConfigs = async (configs) => {
  const response = await apiClient.post('/employee-commission/configs/bulk', { configs });
  return response.data;
};

export const deleteCommissionConfig = async (configId) => {
  const response = await apiClient.delete(`/employee-commission/configs/${configId}`);
  return response.data;
};

// ─── Report API ──────────────────────────────────────────────────────────────

export const generateCommissionReport = async (params) => {
  const response = await apiClient.get('/employee-commission/report', { params });
  return response.data;
};

export const getEmployeeDetailedOrders = async (userId, params) => {
  const response = await apiClient.get(`/employee-commission/report/employees/${userId}/orders`, { params });
  return response.data;
};

/**
 * Fetch the current month commission summary for the logged-in user.
 * Returns { eligible: false } if the user is not a commissioned employee.
 */
export const getMyCommissionSummary = async () => {
  const response = await apiClient.get('/employee-commission/my-summary');
  return response.data;
};

export const getMyCommissionHistory = async () => {
  const response = await apiClient.get('/employee-commission/my-history');
  return response.data;
};

export const getMyDetailedOrders = async (params) => {
  const response = await apiClient.get('/employee-commission/my-orders', { params });
  return response.data;
};

// ─── Commission Business Settings ────────────────────────────────────────────

const COMMISSION_SETTINGS_NAMESPACE = 'employeeCommission';

export const getCommissionSettings = async () => {
  const response = await apiClient.get(`/business-settings/${COMMISSION_SETTINGS_NAMESPACE}`);
  return response.data.settings || {};
};

export const saveCommissionSettings = async (settings) => {
  const response = await apiClient.put(`/business-settings/${COMMISSION_SETTINGS_NAMESPACE}`, { settings });
  return response.data.settings;
};